import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver_profiles_commonCaregiverProfile as CommonCaregiverProfileType } from '@/__generated__/getSearchResults';
import { CAREGIVER_SERVICES } from '@/constants';
import { shuffleWithSeed } from './shuffleWithSeed';

const shuffleCaregiverServices = (
  supportedServices: CommonCaregiverProfileType['supportedServices'],
  seed: number
): string[] => {
  if (!supportedServices) return [];

  const services = Object.entries(supportedServices)
    .filter(
      ([service, value]) =>
        value && CAREGIVER_SERVICES[service] && CAREGIVER_SERVICES[service] !== 'laundry'
    )
    .map(([service]) => CAREGIVER_SERVICES[service]);

  return shuffleWithSeed(services.slice(0, 6), seed);
};

export default shuffleCaregiverServices;
